import React from "react"
import AboutImg from "../../images/about-bros.svg"
import OurGrowth from "../../images/our-growth.png"
import OurPhilosophy from "../../images/our-philosophy.svg"

const WhyWeAre = () => {
  return (
    <div className="container mx-auto md:mt-20 px-6">
      <section className="flex flex-col-reverse lg:flex-row items-center">
        <div className="flex-1 lg:w-1/2">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Why</span> are we here?
          </h1>
          <h3 className="text-3xl pb-4">
            Two brothers with the same passion, the same dream: building their
            careers and <b>enhancing the IT industry</b>.
          </h3>
          <p className="pb-4">
            Our adventure began in 2011, our family bond and mutual trust was
            what prompted us to undertake this one-way journey.
          </p>
          <p className="pb-4">
            We have been in the software development market for more than 10
            years and thanks to the vast experience acquired, AVALITH has become
            a <b>tech-booster company</b>.
          </p>
        </div>
        <div className="flex-1 py-8 md:my-0 w-full lg:w-1/2">
          <img src={AboutImg} alt="Why we are here?" className="mx-auto" />
        </div>
      </section>

      {/* Our Growth & Our philosophy */}
      <section className="py-8">
        {/* Our Growth */}
        <div className="mb-8 lg:py-12">
          <div className="flex flex-col md:flex-row-reverse md:items-center lg:items-end">
            <div className="md:w-3/5 lg:w-1/2 md:pl-4">
              <h3 className="text-5xl font-normal leading-tight pb-8">
                <span className="text-secondary block font-bold">Our</span>{" "}
                growth
              </h3>
              <h4 className="text-3xl font-medium pb-8">
                Starting this company was a great challenge. We learned how to
                make mistakes and never give up. We have always considered
                clients as our top priority, no matter what.
              </h4>
              <p className="pb-8">
                The growth has been constant, we have had the opportunity to
                work with both <b>small businesses</b> and <b>Fortune 500 companies</b>.
              </p>
              <p className="pb-8">
                Throughout this journey we met our colleagues and built our
                current <b>family of more than 100 professionals</b>. This is a solid
                and excellent group of people that is constantly training,
                developing and applying their knowledge in order to be one step
                ahead and provide each client with <b>integral solutions aligned to
                their needs</b>.
              </p>
            </div>
            <div className="my-8 md:my-0 w-full md:w-2/5 lg:w-1/2">
              <img src={OurGrowth} alt="Our Growth" className="mx-auto" />
            </div>
          </div>
        </div>

        <hr className="my-10 md:hidden" />

        {/* Our philosophy */}
        <div className="mb-8 lg:py-12">
          <div className="flex flex-col md:flex-row md:items-center lg:items-start">
            <div className="md:w-3/5 lg:w-1/2 md:pr-4">
              <h3 className="text-5xl font-normal leading-tight pb-8">
                <span className="text-secondary block font-bold">Our</span>{" "}
                philosophy
              </h3>
              <h4 className="text-3xl font-medium pb-8">
                We are passionate about what we do. Our focus is to train and
                boost teams to be reliable, competent and highly professional in
                order to address projects properly.
              </h4>
              <p className="pb-8">
                Our varied and vast history in the market helps us understand
                the dynamics of different sectors and thus, work in a more
                reliable and efficient way.
              </p>
              <p className="pb-8">
                We always encourage our team to be cooperative, coordinated and,
                more importantly, strongly committed to meet the needs of each
                client, providing a world-class service.
              </p>
            </div>
            <div className="my-8 md:my-0 w-full md:w-2/5 lg:w-1/2">
              <img
                src={OurPhilosophy}
                alt="Our philosophy"
                className="mx-auto"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default WhyWeAre
